// extracted by mini-css-extract-plugin
export default {"main_Heading":"timesheet_main_Heading__pyT3m","tableResponsive":"timesheet_tableResponsive__VFNa4","table":"timesheet_table__MHpU5"};